import React from 'react';
import { Outlet } from 'react-router-dom';
import AccountSidebar from '../AccountSidebar/AccountSidebar';
import './AccountLayout.css';

/**
 * AccountLayout component - Shared layout wrapper for all account pages
 * Keeps the sidebar and "Account" title mounted during navigation,
 * preventing layout flashes and jarring transitions between account pages.
 * Child routes render inside <Outlet />.
 */
function AccountLayout() {
    return (
        <div className="account-page">
            <h1 className="account-page-title">Account</h1>
            <div className="account-content">
                <AccountSidebar />
                <div className="account-main">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default AccountLayout;